import React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import FormatDate from '../../../../date/FormatDate'
import TextValue from '../../../../text/TextValue'
import UserInfo from '../Modules/User/UserInfo'

const Form = ({ form = {}, user = {}, detail = {}, loading }) => {

  return (
    <div className='flex flex-col gap-4'>
      <UserInfo
        user={user} 
        loading={loading}
        size="dashboard"
        variant="circle"
      />
      <Box className='grid grid-cols-3 items-center justify-center gap-4'>
        <TextValue title='Date' loading={loading} value={<FormatDate date={form.createdAt} />} />
        <TextValue title='Time' loading={loading} value={<FormatDate date={form.createdAt} pattern='hh:mm a' />} />
        <TextValue title='IP' loading={loading} value={form.ip} />
      </Box>
      <Box className='px-4 py-2 bg-primary text-primary-foreground'>
        <Typography variant='subtitle' className='uppercase'>information action module</Typography>
      </Box>
      <Box className='grid grid-cols-2 items-center justify-center gap-4'>
        <TextValue title='Module' loading={loading} classNameValue="capitalize" value={form.module} />
        <TextValue title='Action' loading={loading} classNameValue="capitalize" value={`${form.action} ${detail?.impersonate ? 'by impersonate' :  ''}`} />
      </Box>
    </div>
  )
}

export default Form